// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>4</span>&nbsp;&nbsp;Let me dwell in your tent for ever&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and take refuge under the cover of your wings.<br> </p> </div></div>";
// Exports
module.exports = code;